// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1sOW_","insightsList":"newBusinessInsightsMenu_insightsList__2C71w","active":"newBusinessInsightsMenu_active__2XReP"};